<template>
    <div class="message-item__content--option-normal">
        <div :class="[
            'option-normal',
            { 'is-options' : mode === 'options' }
        ]">
            <div class="header"
                v-if="title">
                <div class="title">{{title}}</div>
            </div>
            <div class="option__list">
                <div class="option__item"
                    v-for="(item, index) in filterOptions"
                    :key="index"
                    :style="{'--color': color}"
                    @click="clickItem(item)">
                    <div class="option__name">{{item.text}}</div>
                    <span class="option__icon icon_arrow-right"></span>
                </div>
            </div>
            <div class="action">
                <div class="action__item"
                    v-if="options.length > OPTION_COUNT_LIMIT"
                    @click="nextPageForNormal">
                    <div class="action__icon icon_change"></div>
                    <div class="action__name">换一批</div>
                </div>
                <!-- 去掉【以上都不是】 -->
                <!-- <div class="action__item"
                    :class="{
                        'is-disabled': hasClickAllNot
                    }"
                    v-if="allNotText"
                    @click="allNot">
                    <div class="action__name">{{allNotText}}</div>
                    <div class="action__icon icon_enter"></div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import { MESSAGE_NAME } from '@/constants/message'
    import { paging } from '@/utils'
    import { sendMessage } from '@/utils/message_send'
    import clickAllNotMixin from '../../mixins/clickAllNot'

    const OPTION_COUNT_LIMIT = 5

    export default {
        name: 'MessageContentOptionNormal',
        mixins: [ clickAllNotMixin ],
        props: {
            mode: {
                type: String,
                default: 'normal' // normal、no_answer、options
            },
            title: {
                type: String,
                required: true
            },
            allNotText: {
                type: String,
                required: false
            },
            options: {
                type: Array,
                required: true
            },
            idFromServer: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                OPTION_COUNT_LIMIT,
                pageNumForNormal: 0
            }
        },
        computed: {
            filterOptions () {
                if (this.options.length > OPTION_COUNT_LIMIT) {
                    return paging(this.options, this.pageNumForNormal, OPTION_COUNT_LIMIT)
                } else {
                    return this.options
                }
            },
            theme () {
                return this.$eventBus.theme
            },
            color () {
                if (this.theme === 'white') {
                    return this.$store.state.theme.color
                }
                return this.$store.state.lingkeColor
            }
        },
        methods: {
            nextPageForNormal () {
                this.pageNumForNormal += 1

                const totalPage = Math.ceil(this.options.length / OPTION_COUNT_LIMIT)

                if (this.pageNumForNormal >= totalPage) {
                    this.pageNumForNormal = 0
                }
            },
            clickItem ({ text }) {
                sendMessage({
                    type: 'base',
                    detailType: MESSAGE_NAME.TEXT,
                    content: text
                })
                this.$eventBus.$emit('showinputstatus', {is_input:true})
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../css/option_list.scss";

    .option-normal {
        width: 245px;
        overflow: hidden;
        font-size: 14px;
        color: $primary-text-color;
        background-color: #FFFFFF;
        box-shadow: $primary-box-shadow;
        @include radius(.25, .5, .5, .5);

        @include desktop {
            width: auto;
            min-width: 245px;
            max-width: 560px;
        }

        &.is-options {
            .option {
                &__item {
                    color: $primary-color;
                }
                &__icon {
                    color: $primary-color;
                }
            }
        }
    }

    .header {
        padding: 10px 15px;
        white-space: pre-wrap;
        border-bottom: 1px solid #E1E2E4;
        position: relative;

        &::before {
            content: '';
            display: block;
            width: 2px;
            min-height: 14px;
            position: absolute;
            left: 0;
            top: 12px;
            bottom: 12px;
            // background: #5682F8;
            border-radius: 0 62px 62px 0;
        }
    }

    .title {
        font-size: 14px;
        font-weight: 600;
        line-height: (20 / 14);
    }

    .action {
        &__item {
            @include flex-center;
            padding: 0 15px;
            color: $primary-color;
            border-top: 1px solid #E1E2E4;
            cursor: pointer;

            // &:not(.is-disabled) {
            //     &:active {
            //         background-color: darken(#FAFAFA, 7%);
            //     }

            //     @include ie {
            //         &:hover {
            //             background-color: darken(#FAFAFA, 7%);
            //         }
            //     }
            // }

            // &.is-disabled {
            //     cursor: not-allowed;

            //     .action__name,
            //     .action__icon {
            //         opacity: .3;
            //     }
            // }
        }

        &__name {
            font-size: 14px;
            line-height: (39 / 14);
            @include text-line;
        }

        &__icon {
            font-size: 14px;
            flex-shrink: 0;
            flex-grow: 0;
            margin-right: 5px;
        }
    }
</style>
